import React, { useState, useEffect, Fragment } from 'react';
import { translate } from '../../../Services/translation';
import { useDispatch, useSelector } from 'react-redux';
import BuyButton from '../../BuyButton';
import { SubscriptionIntiatedStatus, SubscriptionCancelledStatus, SubscriptionPausedStatus, SubscriptionActiveStatus } from '../../../constants';
import SimplePopup from '../../SimplePopUp';
import MyPageSubscriptionPauseOrCancel from './MyPageSubscriptionPauseOrCancel';
import { post, get } from '../../../Services/http';
import MyPageSubscriptionEdit from './MyPageSubscriptionEdit';
import { add as addToCartService } from '../../../Services/Cart.service';
import { receive } from '../../../Actions/Cart.action';
import { lensspecificationconstants } from '../../../lensspecificationconstants';
import ReactivateFromPausePopUp from './ReactivateFromPausePopUp';

const MyPageSubscription = (props) => {
  const customerSubscription =
    props.customerSubscription && JSON.parse(props.customerSubscription);
  const upcomingSubscription =
    props.upcomingSubscription && JSON.parse(props.upcomingSubscription);
  const href = '#';
  const [leftEyePacket, setLeftEyePacket] = useState('');
  const [rightEyePacket, setRightEyePacket] = useState('');
  const [showPauseCancel, setshowPauseCancel] = useState(false);
  const [generalErrors, setgeneralErrors] = useState([]);
  const [editClicked, seteditClicked] = useState(false);
  const [addToCartError, setaddToCartError] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [showDeleteConfirmPopUp, setshowDeleteConfirmPopUp] = useState(false);
  const [cancelReactivateInstructions, setcancelReactivateInstructions] = useState("");
  const [showReactivateFromPausePopup, setshowReactivateFromPausePopup] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [showCardUpdate, setshowCardUpdate] = useState(false);

  var cartState = useSelector((state) => state.cart);
  const handleButtonClick = () => {
    setShowPopup(true);
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleIsProcessing = async () => {
    setIsProcessing(true);
  };

  const statusClass = customerSubscription ? (customerSubscription.newSubscriptionDeliveryFailed ? 'ActiveDeliveryFailed' : customerSubscription.status) : "";

  const dispatch = useDispatch();

  const anyProductNotBuyable = (customerSubscription && customerSubscription.customerSubscriptionItemLeft &&
    customerSubscription.customerSubscriptionItemLeft.articleNumber &&
    !customerSubscription.customerSubscriptionItemLeft.canBuy)
    || (customerSubscription && customerSubscription.customerSubscriptionItemRight && customerSubscription.customerSubscriptionItemRight.articleNumber &&
      !customerSubscription.customerSubscriptionItemRight.canBuy);

  let cssClass = customerSubscription && !anyProductNotBuyable
    ? 'button buy-button product-detail__buy-button'
    : 'button buy-button product-detail__buy-button  disabled';

  let leftArticleNumber = customerSubscription && customerSubscription.customerSubscriptionItemLeft ? customerSubscription.customerSubscriptionItemLeft.articleNumber : "";
  let rightArticleNumber = customerSubscription && customerSubscription.customerSubscriptionItemRight ? customerSubscription.customerSubscriptionItemRight.articleNumber : "";


  useEffect(() => {
    if (customerSubscription && customerSubscription.status === SubscriptionCancelledStatus) {
      get(`/api/customer/getcancelreactivateinstructions/${false}`)
        .then((response) => response.text())
        .then((result) => {
          setcancelReactivateInstructions(result);
        });
    }
  }, []);

  useEffect(() => {
    if (customerSubscription) {
      if (customerSubscription.customerSubscriptionItemLeft && customerSubscription.customerSubscriptionItemLeft.packet) {
        setLeftEyePacket(customerSubscription.customerSubscriptionItemLeft.packet);
      }
      if (customerSubscription.customerSubscriptionItemRight && customerSubscription.customerSubscriptionItemRight.packet) {
        setRightEyePacket(customerSubscription.customerSubscriptionItemRight.packet);
      }
    }

  }, [props.customerSubscription]);

  const AddDummyProductToCart = async () => {
    post('api/cart/adddummyproduct').then(() => handleButtonClick());
  }

  const addItemsToCart = async () => {
    try {
      const cartRight = await addToCartService({
        articleNumber: customerSubscription.customerSubscriptionItemRight.articleNumber,
        quantity: 1,
        rightStrength: customerSubscription.customerSubscriptionItemRight.strength,
        rightCurve: customerSubscription.customerSubscriptionItemRight.curve,
        rightDiameter: customerSubscription.customerSubscriptionItemRight.diameter,
        rightCylinder: customerSubscription.customerSubscriptionItemRight.cylinder,
        rightAxis: customerSubscription.customerSubscriptionItemRight.axis,
        rightEyeAdd: customerSubscription.customerSubscriptionItemRight.add,
        rightColor: customerSubscription.customerSubscriptionItemRight.color,
        rightPacket: rightEyePacket,
        rightEyeProductNumber: customerSubscription.customerSubscriptionItemRight.eyeProductNumber,
        subscription: true,
        lensDurationCategory: customerSubscription.customerSubscriptionItemRight.lensDurationCategory,
        clinicalPartActive: customerSubscription.clinicalPartActive,
      });
      const cartLeft = await addToCartService({
        articleNumber: customerSubscription.customerSubscriptionItemLeft.articleNumber,
        quantity: 1,
        leftStrength: customerSubscription.customerSubscriptionItemLeft.strength,
        leftCurve: customerSubscription.customerSubscriptionItemLeft.curve,
        leftDiameter: customerSubscription.customerSubscriptionItemLeft.diameter,
        leftCylinder: customerSubscription.customerSubscriptionItemLeft.cylinder,
        leftAxis: customerSubscription.customerSubscriptionItemLeft.axis,
        leftEyeAdd: customerSubscription.customerSubscriptionItemLeft.add,
        leftColor: customerSubscription.customerSubscriptionItemLeft.color,
        leftPacket: leftEyePacket,
        leftEyeProductNumber: customerSubscription.customerSubscriptionItemLeft.eyeProductNumber,
        subscription: true,
        lensDurationCategory: customerSubscription.customerSubscriptionItemLeft.lensDurationCategory,
        clinicalPartActive: customerSubscription.clinicalPartActive,
      });

      if (cartLeft === lensspecificationconstants.InternalServerError || cartRight === lensspecificationconstants.InternalServerError) {
        setaddToCartError(true);
      } else {
        setaddToCartError(false);
        handleButtonClick();
        get(`/api/cart`)
          .then((response) => response.json())
          .then((result) => {
            dispatch(receive(result));
          });
      }
    }
    catch (ex) {
      setaddToCartError(true);
    }
  }

  useEffect(() => {
    if (cartState.error && cartState.error.length > 0) {
      setaddToCartError(true);
    }
  }, [cartState, cartState.error]);

  const reactivateSubscription = () => {
    post(`/api/customer/reactivatesubscription/${customerSubscription.customerSystemId}`)
      .then(() => {
        setshowReactivateFromPausePopup(false);
        refreshExistingSubscription();        
      })
      .catch((error) => {
        if (error.response.status === 500) {
          setgeneralErrors([translate('coptikk.adminportal.subscription.generalerror')]);
          setTimeout(() => {
            setshowPauseCancel(false);
          }, 1000);
        }
      });
  }

  const cancelSubscription = () => {
    post(`/api/customer/pauseorcancelsubscription/${customerSubscription.customerSystemId}/${true}`)
      .then(() => {
        refreshExistingSubscription();
      });
  }

  const pauseSubscription = () => {
    post(`/api/customer/pauseorcancelsubscription/${customerSubscription.customerSystemId}`)
      .then(() => {
        refreshExistingSubscription();
      })
      .catch((error) => {
        if (error.response.status === 500) {
          setgeneralErrors([translate('coptikk.adminportal.subscription.generalerror')]);
          setTimeout(() => {
            setshowPauseCancel(false);
          }, 1000);
        }
      });
  }


  const deleteSubscription = () => {
    post(`/api/customer/deletesubscription/${customerSubscription.customerSystemId}`)
      .then(() => {
        refreshExistingSubscription();
      })
      .catch((error) => {
        props.refresh();
      });
  }

  const refreshExistingSubscription = () => {
    if (window.location.href.indexOf("?currentTab=subscriptions") > -1) {
      window.location.href = window.location.href;
    } else {
      window.location.href = window.location.href + "?currentTab=subscriptions";
    }
  }

  return (
    <Fragment>
      {customerSubscription && customerSubscription.status ? <>
        {addToCartError && <div className='error'>{translate("coptikk.mypage.subscription.addtocartfailed")}</div>}
        {!editClicked ? <>
          {showPopup && (
            <SimplePopup onClose={handleClosePopup} checkoutUrl={props.checkoutUrl} />
          )}
          <div className='row mypage-subscription__row'>
            <div className='mypage-subscription__column'>
              {customerSubscription.newSubscriptionPaymentTokenRequired && <div className='row mypage-subscription__regeneratetokenrow'>
                  <div className='columns'>
                    <h4>Start her for å lagre kortopplysninger:</h4>
                    <a className='mypage-subscription__regeneratetoken' onClick={() => AddDummyProductToCart()}>
                      {translate("coptikk.general.subscription.regeneratetoken")}
                    </a>  
                  </div>                  
              </div>}
              {customerSubscription.newSubscriptionDeliveryFailed && <div className='row mypage-subscription__regeneratetokenrow'>
                  <div className='columns'>
                    <h4>{translate("coptikk.subscription.deliveryfailed.header")}</h4>
                    <div className='mypage-subscription__deliveryfailed'>
                      {translate("coptikk.subscription.deliveryfailed.message")}
                    </div>  
                  </div>                  
              </div>}
              <div key={`${leftArticleNumber}${rightArticleNumber}`} className={leftArticleNumber === rightArticleNumber ? 'my-recommendations__container' : 'my-recommendations__container-column'}>
                {
                  customerSubscription.customerSubscriptionItemRight && customerSubscription.customerSubscriptionItemRight.articleNumber &&
                  <div>
                    <div className='mypage-subscription__product'>
                      <div className='mypage-subscription__product-top-container'>
                        <div className='mypage-subscription__product-info'>
                          <div className='my-recommendations__product-name'>
                            {customerSubscription.customerSubscriptionItemRight.name}
                          </div>
                          <div className='my-recommendations__product-category'>
                            {customerSubscription.customerSubscriptionItemRight.categoryName}
                          </div>
                        </div>
                        <div className='my-recommendations__product-image'>
                          <img src={customerSubscription.customerSubscriptionItemRight.productImageUrl}></img>
                        </div>
                      </div>
                      <div className='my-recommendations__eye-spec-wrapper'>
                        <div>
                          <div className='my-recommendations__eye'>
                            {translate('coptikk.product.righteye')}
                          </div>
                          <div className={leftArticleNumber !== rightArticleNumber ? 'column small-12 my-recommendations__spec-row' : 'column small-12 my-recommendations__spec-row'}>
                            {customerSubscription.customerSubscriptionItemRight.strength && <span className='my-recommendations__spec'>{customerSubscription.customerSubscriptionItemRight.strength}</span>}
                            {customerSubscription.customerSubscriptionItemRight.curve &&
                              <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.curve.short')}: {customerSubscription.customerSubscriptionItemRight.curve}</span>}
                            {customerSubscription.customerSubscriptionItemRight.diameter &&
                              <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.diameter.short')}: {customerSubscription.customerSubscriptionItemRight.diameter}</span>}
                            {customerSubscription.customerSubscriptionItemRight.cylinder &&
                              <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.cylinder.short')}: {customerSubscription.customerSubscriptionItemRight.cylinder}</span>}
                            {customerSubscription.customerSubscriptionItemRight.axis &&
                              <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.axis')}: {customerSubscription.customerSubscriptionItemRight.axis}</span>}
                            {customerSubscription.customerSubscriptionItemRight.add &&
                              <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.addfield')}: {customerSubscription.customerSubscriptionItemRight.add}</span>}
                            {customerSubscription.customerSubscriptionItemRight.color &&
                              <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.color')}: {customerSubscription.customerSubscriptionItemRight.color}</span>}
                          </div>
                        </div>
                        <div className='row'>
                          <div className={leftArticleNumber === rightArticleNumber ? 'column small-6' : 'column small-3'}>
                            <select value={rightEyePacket} onChange={(e) => setRightEyePacket(e.target.value)} disabled={true}>
                              {customerSubscription.customerSubscriptionItemRight.packetList.map(x => {
                                return <option value={x}>{x} {translate('coptikk.price.unit')} {customerSubscription.customerSubscriptionItemRight.price},-</option>
                              })}
                              {customerSubscription.customerSubscriptionItemRight.packetList.indexOf(rightEyePacket) < 0 &&
                                <option value={rightEyePacket}>{rightEyePacket} {translate('coptikk.price.unit')} {customerSubscription.customerSubscriptionItemRight.price},-</option>
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                {
                  customerSubscription.customerSubscriptionItemLeft && customerSubscription.customerSubscriptionItemLeft.articleNumber &&
                  <div>
                    <div className='mypage-subscription__product'>
                      {(leftArticleNumber !== rightArticleNumber) &&
                        <div className='mypage-subscription__product-top-container'>
                          <div className='mypage-subscription__product-info'>
                            <div className='my-recommendations__product-name'>
                              {customerSubscription.customerSubscriptionItemLeft.name}
                            </div>
                            <div className='my-recommendations__product-category'>
                              {customerSubscription.customerSubscriptionItemLeft.categoryName}
                            </div>
                          </div>
                          <div className='my-recommendations__product-image'>
                            <img src={customerSubscription.customerSubscriptionItemLeft.productImageUrl}></img>
                          </div>
                        </div>
                      }
                      <div className='small-6 my-recommendations__eye-spec-wrapper'>
                        <div className='row'>
                          <div className='column small-8 my-recommendations__eye'>
                            {translate('coptikk.product.lefteye')}
                          </div>
                        </div>
                        <div>
                          <div className={leftArticleNumber !== rightArticleNumber ? 'column small-12 my-recommendations__spec-row' : 'column small-12 my-recommendations__spec-row'}>
                            {customerSubscription.customerSubscriptionItemLeft.strength && <span className='my-recommendations__spec'>{customerSubscription.customerSubscriptionItemLeft.strength}</span>}
                            {customerSubscription.customerSubscriptionItemLeft.curve &&
                              <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.curve.short')}: {customerSubscription.customerSubscriptionItemLeft.curve}</span>}
                            {customerSubscription.customerSubscriptionItemLeft.diameter &&
                              <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.diameter.short')}: {customerSubscription.customerSubscriptionItemLeft.diameter}</span>}
                            {customerSubscription.customerSubscriptionItemLeft.cylinder &&
                              <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.cylinder.short')}: {customerSubscription.customerSubscriptionItemLeft.cylinder}</span>}
                            {customerSubscription.customerSubscriptionItemLeft.axis &&
                              <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.axis')}: {customerSubscription.customerSubscriptionItemLeft.axis}</span>}
                            {customerSubscription.customerSubscriptionItemLeft.add &&
                              <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.addfield')}: {customerSubscription.customerSubscriptionItemLeft.add}</span>}
                            {customerSubscription.customerSubscriptionItemLeft.color &&
                              <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.color')}: {customerSubscription.customerSubscriptionItemLeft.color}</span>}
                          </div>
                        </div>
                        <div className='row'>
                          <div className={leftArticleNumber === rightArticleNumber ? 'column small-6' : 'column small-3'}>
                            <select value={leftEyePacket} onChange={(e) => setLeftEyePacket(e.target.value)} disabled={true}>
                              {customerSubscription.customerSubscriptionItemLeft.packetList.map(x => {
                                return <option value={x}>{x} {translate('coptikk.price.unit')} {customerSubscription.customerSubscriptionItemLeft.price},-</option>
                              })}
                              {customerSubscription.customerSubscriptionItemLeft.packetList.indexOf(leftEyePacket) < 0 &&
                                <option value={leftEyePacket}>{leftEyePacket} {translate('coptikk.price.unit')} {customerSubscription.customerSubscriptionItemLeft.price},-</option>
                              }
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              {customerSubscription.clinicalPartActive && (
                <div className='row mypage-subscription__clinical-addition'>
                  <div className='wrapper'>
                    <div className='checkbox-wrapper'>
                      <p className='title'>{translate("coptikk.general.clinicalexamination")}</p>
                      <input type='checkbox' checked className='checkbox'></input>
                    </div>
                    <p className='description'>{translate("coptikk.general.clinicalexamination.mypage.description")}</p>
                  </div>
                </div>
              )}
              <div className='row'>
                <div className='columns'>
                  {customerSubscription && customerSubscription.status !== SubscriptionIntiatedStatus &&
                  (customerSubscription.status === SubscriptionCancelledStatus ? customerSubscription.allPaymentsDone : true) &&
                    <a className="edit-subscription" onClick={() => seteditClicked(true)}>{translate("coptikk.adminportal.subscription.update")}</a>
                  }
                </div>                
              </div>              
            </div>

            <div className='mypage-subscription__column'>
              {customerSubscription.status === SubscriptionIntiatedStatus ?
                <div className='mypage-subscription__complete-wrapper'>
                  <p className='title'>
                    {translate("coptikk.mypages.customertocompletesubscription.header")}
                  </p>
                  <p className='description'>
                    {translate("coptikk.mypages.customertocompletesubscription.description")}
                  </p>
                </div> :
                <div>
                  {!showPauseCancel && !showCardUpdate && <div className='mypage-subscription__action-wrapper'>
                    <div className='mypage-subscription__action-row'>
                      <p className='key'>{translate("coptikk.adminportal.subscription.statustext")}</p>
                      <p className={`status ${statusClass}`}>{customerSubscription.statusTranslation}</p>
                    </div>
                    <div className='mypage-subscription__action-row'>
                      <p className='key'>{`${translate("coptikk.adminportal.subscription.pricetext")} ${translate("coptikk.product.subscription.permonthtext")}`}</p>
                      <p className='value'>
                        {customerSubscription.pricePerMonth % 1 === 0
                          ? `${customerSubscription.pricePerMonth.toLocaleString("nb-NO", { maximumFractionDigits: 0 })},-`
                          : customerSubscription.pricePerMonth.toLocaleString("nb-NO", { maximumFractionDigits: 2, minimumFractionDigits: 2 })
                        }
                      </p>
                    </div>

                    {customerSubscription.nextPaymentDates && customerSubscription.nextPaymentDates.map((x, index) => {
                      return <>
                        <div className='mypage-subscription__action-row'>
                          <p className='key'>{index === 0 ? translate("coptikk.adminportal.subscription.nextpaymenttext") : ""}</p>
                          <p className='value'>{x}</p>
                        </div></>
                    })}
                    <div className='mypage-subscription__action-row'>
                      <p className='key'>{translate("coptikk.adminportal.subscription.nextdeliverytext")}</p>
                      <p className='value'>{customerSubscription.nextDeliveryDate}</p>
                    </div>
                    <div className='mypage-subscription__action-row'>
                      <p className='key'>{translate("coptikk.adminportal.subscription.deliveryaddresstext")}</p>
                      <p className='value'>{customerSubscription.deliveryAddress}</p>
                    </div>
                    <div className='mypage-subscription__action-row'>
                      <p className='key'>{translate("coptikk.adminportal.subscription.paymentmethodtext")}</p>
                      <p className='value'>{customerSubscription.paymentMethod}</p>
                    </div>
                  </div>}
                  {!showCardUpdate && !showPauseCancel && <div className='mypage-subscription__update-card-container'>
                    <button className='button secondary' onClick={() => setshowCardUpdate(true)}>{translate("coptikk.mypage.updatecard.buttontext")}</button>
                    {customerSubscription.status === SubscriptionCancelledStatus ? (
                      <Fragment></Fragment>
                    ) : customerSubscription.status === SubscriptionPausedStatus ? (
                      <button className="button" onClick={() => setshowPauseCancel(!showPauseCancel)}>{translate("coptikk.adminportal.subscription.cancel")}</button>
                    ) : (
                      <button className="button" onClick={() => setshowPauseCancel(!showPauseCancel)}>{translate("coptikk.adminportal.subscription.pauseorstoptext")}</button>
                    )}
                  </div>}
                  {generalErrors && generalErrors.length > 0 && generalErrors.map(errorItem => {
                    return <div className='error'>{errorItem}</div>
                  })}
                  {showPauseCancel && <MyPageSubscriptionPauseOrCancel pauseSubscription={() => pauseSubscription()} cancelSubscription={() => cancelSubscription()}
                    hide={() => setshowPauseCancel(false)} refresh={() => refreshExistingSubscription()} subscriptionStatus={customerSubscription.status}>
                  </MyPageSubscriptionPauseOrCancel>}
                  {showCardUpdate && <div className='mypage-subscription__update-card--wrapper'>
                      <a onClick={() => setshowCardUpdate(false)} className='mypage-subscription__go-back-button'>{translate("coptikk.mypage.updatecard.back")}</a>
                      <div className='mypage-subscription__update-card--header'>{translate("coptikk.mypage.updatecard.header")}</div>
                      <div className='mypage-subscription__update-card--description'>{translate("coptikk.mypage.updatecard.descriptiontext")}</div>
                      <div className='mypage-subscription__update-card--description' dangerouslySetInnerHTML={{ __html: translate("coptikk.mypage.updatecard.description.steps")}}></div>
                      <button className='button secondary mypage-subscription__update-card--button' onClick={() => AddDummyProductToCart()}>{translate("coptikk.mypage.updatecard.buttontext")}</button>
                    </div>
                  }
                  {customerSubscription.status === SubscriptionCancelledStatus &&
                    <div>
                      <div dangerouslySetInnerHTML={{ __html: cancelReactivateInstructions }}></div>
                      <div className='mypage-subscription__cancel-button-container'>
                        {(customerSubscription.inactiveProductExists || !customerSubscription.allPaymentsDone) ?
                          <a className='button disabled'>{translate("coptikk.mypage.subscription.reactivate")}</a>
                          : <a className='button' onClick={() => reactivateSubscription()}>{translate("coptikk.mypage.subscription.reactivate")}</a>}
                        {customerSubscription.allPaymentsDone && 
                            <a className='button' onClick={() => setshowDeleteConfirmPopUp(true)}>{translate("coptikk.mypage.subscription.delete")}</a>}
                      </div>
                    </div>
                  }
                  {customerSubscription.status === SubscriptionPausedStatus &&
                    <div className='mypage-subscription__paused-button-container'>
                      {customerSubscription.inactiveProductExists ?
                        <a className='button expanded disabled'>{translate("coptikk.mypage.subscription.reactivate")}</a>
                        : <a className='button expanded' onClick={() => customerSubscription.allPaymentsDone ? setshowReactivateFromPausePopup(true)
                          : reactivateSubscription()}>{translate("coptikk.mypage.subscription.reactivate")}</a>}
                    </div>
                  }                  
                </div>
              }
              {showDeleteConfirmPopUp &&
                <div className='subscription-pop-up'>
                  <div className='subscription-pop-up__content'>
                    <h2 className='subscription-pop-up__title'>{translate("coptikk.mypage.subscription.pauseorcancelconfirmheader")}</h2>
                    <p className='subscription-pop-up__description'>{translate("coptikk.mypage.subscription.pauseorcancelconfirmdescription")}</p>
                    <a className='subscription-pop-up__pause-button' onClick={() => deleteSubscription()}>{translate("coptikk.mypage.subscription.pauseorcancelconfirmbuttontext")}</a>
                    <a className='subscription-pop-up__cancel-button' onClick={() => setshowDeleteConfirmPopUp(false)}>{translate("coptikk.mypage.subscription.pauseorcancelconfirmcancel")}</a>
                  </div>
                </div>
              }
              {
                showReactivateFromPausePopup && <ReactivateFromPausePopUp hidePopUp={() => setshowReactivateFromPausePopup(false)}
                customerSystemId={customerSubscription.customerSystemId} reactivateSubscription={() => reactivateSubscription()}
                refresh={() => refreshExistingSubscription()}></ReactivateFromPausePopUp>
              }
              {customerSubscription.status === SubscriptionIntiatedStatus && <div>
                {anyProductNotBuyable && <div className="product-detail__alert-message">
                  <div className="alert-icon">!</div>
                  <div className="text">{translate("coptikk.subscription.product.alert.message")}</div>
                </div>}
                <div className='mypage-subscription__price-container'>
                  <div>{`${translate("coptikk.adminportal.subscription.pricetext")} (${translate("coptikk.product.subscription.permonthtext")})`}</div>
                  <div>
                    {customerSubscription.pricePerMonth % 1 === 0
                      ? `${customerSubscription.pricePerMonth.toLocaleString("nb-NO", { maximumFractionDigits: 0 })},-`
                      : customerSubscription.pricePerMonth.toLocaleString("nb-NO", { maximumFractionDigits: 2, minimumFractionDigits: 2 })
                    }
                  </div>
                </div>
                {((leftArticleNumber === rightArticleNumber) || (leftArticleNumber === "" && rightArticleNumber !== "")
                  || (leftArticleNumber !== "" && rightArticleNumber === "")) ? <div className="mypage-subscription__buy-button-wrapper">
                  <BuyButton
                    label={customerSubscription.customerSubscriptionItemLeft && customerSubscription.customerSubscriptionItemLeft !== null ?
                      customerSubscription.customerSubscriptionItemLeft.label :
                      customerSubscription.customerSubscriptionItemRight.label}
                    articleNumber={leftArticleNumber ? leftArticleNumber : rightArticleNumber}
                    href={href}
                    cssClass={
                      (leftEyePacket !== '0' || rightEyePacket !== '0')
                        ? cssClass
                        : `${cssClass} disabled `
                    }
                    handleBuyButtonClick={handleButtonClick}
                    handleIsProcessing={handleIsProcessing}
                    setIsProcessing={setIsProcessing}
                    rightStrength={customerSubscription.customerSubscriptionItemRight ? customerSubscription.customerSubscriptionItemRight.strength : ""}
                    rightCurve={customerSubscription.customerSubscriptionItemRight ? customerSubscription.customerSubscriptionItemRight.curve : ""}
                    rightDiameter={customerSubscription.customerSubscriptionItemRight ? customerSubscription.customerSubscriptionItemRight.diameter : ""}
                    rightCylinder={customerSubscription.customerSubscriptionItemRight ? customerSubscription.customerSubscriptionItemRight.cylinder : ""}
                    rightAxis={customerSubscription.customerSubscriptionItemRight ? customerSubscription.customerSubscriptionItemRight.axis : ""}
                    rightEyeAdd={customerSubscription.customerSubscriptionItemRight ? customerSubscription.customerSubscriptionItemRight.add : ""}
                    rightColor={customerSubscription.customerSubscriptionItemRight ? customerSubscription.customerSubscriptionItemRight.color : ""}
                    rightPacket={rightEyePacket}
                    rightCylinderHasOptions={customerSubscription.customerSubscriptionItemRight && customerSubscription.customerSubscriptionItemRight.cylinder}
                    rightAxisHasOptions={customerSubscription.customerSubscriptionItemRight && customerSubscription.customerSubscriptionItemRight.axis}
                    rightAddHasOptions={customerSubscription.customerSubscriptionItemRight && customerSubscription.customerSubscriptionItemRight.add}
                    rightColorHasOptions={customerSubscription.customerSubscriptionItemRight && customerSubscription.customerSubscriptionItemRight.color}
                    rightEyeProductNumber={customerSubscription.customerSubscriptionItemRight && customerSubscription.customerSubscriptionItemRight.eyeProductNumber}

                    leftStrength={customerSubscription.customerSubscriptionItemLeft ? customerSubscription.customerSubscriptionItemLeft.strength : ""}
                    leftCurve={customerSubscription.customerSubscriptionItemLeft ? customerSubscription.customerSubscriptionItemLeft.curve : ""}
                    leftDiameter={customerSubscription.customerSubscriptionItemLeft ? customerSubscription.customerSubscriptionItemLeft.diameter : ""}
                    leftCylinder={customerSubscription.customerSubscriptionItemLeft ? customerSubscription.customerSubscriptionItemLeft.cylinder : ""}
                    leftAxis={customerSubscription.customerSubscriptionItemLeft ? customerSubscription.customerSubscriptionItemLeft.axis : ""}
                    leftEyeAdd={customerSubscription.customerSubscriptionItemLeft ? customerSubscription.customerSubscriptionItemLeft.add : ""}
                    leftColor={customerSubscription.customerSubscriptionItemLeft ? customerSubscription.customerSubscriptionItemLeft.color : ""}
                    leftPacket={leftEyePacket}
                    leftCylinderHasOptions={customerSubscription.customerSubscriptionItemLeft && customerSubscription.customerSubscriptionItemLeft.cylinder}
                    leftAxisHasOptions={customerSubscription.customerSubscriptionItemLeft && customerSubscription.customerSubscriptionItemLeft.axis}
                    leftAddHasOptions={customerSubscription.customerSubscriptionItemLeft && customerSubscription.customerSubscriptionItemLeft.add}
                    leftColorHasOptions={customerSubscription.customerSubscriptionItemLeft && customerSubscription.customerSubscriptionItemLeft.color}
                    leftEyeProductNumber={customerSubscription.customerSubscriptionItemLeft && customerSubscription.customerSubscriptionItemLeft.eyeProductNumber}

                    excludeRightValidations={!customerSubscription.customerSubscriptionItemRight}
                    excludeLeftValidations={!customerSubscription.customerSubscriptionItemLeft}
                    subscription={true}
                    clinicalPartActive={customerSubscription.clinicalPartActive}
                  />
                  {(leftEyePacket === '0' || rightEyePacket === '0') && (
                    <div>
                      {translate('coptikk.product.youmustselect')}{' '}
                      {translate('coptikk.product.packets')}
                    </div>
                  )}
                  <a className='button button-delete-initiate' onClick={() => setshowDeleteConfirmPopUp(true)}>{translate("coptikk.mypage.subscription.delete")}</a>
                </div> :
                  <div className="mypage-subscription__buy-button-wrapper">
                    <button className={`button buy-button ${anyProductNotBuyable ? "  disabled" : ""}`}
                      onClick={() => anyProductNotBuyable ? null : addItemsToCart()}
                    >
                      {customerSubscription.customerSubscriptionItemLeft.label ? customerSubscription.customerSubscriptionItemLeft.label :
                        customerSubscription.customerSubscriptionItemRight.label}
                    </button>
                    <a className='button button-delete-initiate' onClick={() => setshowDeleteConfirmPopUp(true)}>{translate("coptikk.mypage.subscription.delete")}</a>
                  </div>}
              </div>}
              {(customerSubscription.status === SubscriptionActiveStatus || customerSubscription.status === SubscriptionPausedStatus
              || customerSubscription.status === SubscriptionCancelledStatus) && upcomingSubscription &&
                upcomingSubscription?.customerSystemId !== null &&
                <div className='mypage-subscription__update-wrapper'>
                  <p className='updated-by'>{`${translate("coptikk.subscription.edit.updatedby")} ${upcomingSubscription.savedByCustomer ?
                    translate("coptikk.subscription.edit.updatedby.customer") : translate("coptikk.subscription.edit.updatedby.store")}
                      ${upcomingSubscription.savedDate}`}</p>
                  <div className='info-row'>
                    <p className='active-date'>{translate("coptikk.subscription.entersintoforcetext")}</p>
                    <p className='active-date'>
                      {customerSubscription.nextStartDateIfEdited}
                    </p>
                  </div>
                  <div className='info-row'>
                    <p className='updated-price'>{translate("coptikk.subscription.updatedprice.permonth")}</p>
                    <p className='updated-price'>
                      {upcomingSubscription.pricePerMonth % 1 === 0
                        ? `${upcomingSubscription.pricePerMonth.toLocaleString("nb-NO", { maximumFractionDigits: 0 })},-`
                        : upcomingSubscription.pricePerMonth.toLocaleString("nb-NO", { maximumFractionDigits: 2, minimumFractionDigits: 2 })
                      }
                    </p>
                  </div>
                  <p className='updated-price-info'>{translate("coptikk.subscription.edit.pricechangeinfo")}</p>
                  {upcomingSubscription.customerSubscriptionItemRight !== null && <div>
                    <div className='my-recommendations__eye-row'>
                      <div className='my-recommendations__eye'>
                        {translate('coptikk.product.righteye')}:
                      </div>
                      <div className={'my-recommendations__spec-row'}>
                        {upcomingSubscription.customerSubscriptionItemRight.strength && <span className='my-recommendations__spec'>{upcomingSubscription.customerSubscriptionItemRight.strength}</span>}
                        {upcomingSubscription.customerSubscriptionItemRight.curve &&
                          <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.curve.short')}: {upcomingSubscription.customerSubscriptionItemRight.curve}</span>}
                        {upcomingSubscription.customerSubscriptionItemRight.diameter &&
                          <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.diameter.short')}: {upcomingSubscription.customerSubscriptionItemRight.diameter}</span>}
                        {upcomingSubscription.customerSubscriptionItemRight.cylinder &&
                          <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.cylinder.short')}: {upcomingSubscription.customerSubscriptionItemRight.cylinder}</span>}
                        {upcomingSubscription.customerSubscriptionItemRight.axis &&
                          <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.axis')}: {upcomingSubscription.customerSubscriptionItemRight.axis}</span>}
                        {upcomingSubscription.customerSubscriptionItemRight.add &&
                          <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.addfield')}: {upcomingSubscription.customerSubscriptionItemRight.add}</span>}
                        {upcomingSubscription.customerSubscriptionItemRight.color &&
                          <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.color')}: {upcomingSubscription.customerSubscriptionItemRight.color}</span>}
                      </div>
                    </div>
                    {upcomingSubscription.customerSubscriptionItemLeft !== null && upcomingSubscription.customerSubscriptionItemRight.name !==
                      upcomingSubscription.customerSubscriptionItemLeft.name &&
                      <div className='my-recommendations__eye-row'>
                        <div className='my-recommendations__eye'>
                          {translate('coptikk.subscription.edit.product')}:
                        </div>
                        <div className={'my-recommendations__spec-row'}>
                          <span className='my-recommendations__spec'>{upcomingSubscription.customerSubscriptionItemRight.name}</span>
                        </div>
                      </div>}
                  </div>}
                  {upcomingSubscription.customerSubscriptionItemLeft !== null && <div>
                    <div className='my-recommendations__eye-row'>
                      <div className='my-recommendations__eye'>
                        {translate('coptikk.product.lefteye')}:
                      </div>
                      <div className={'my-recommendations__spec-row'}>
                        {upcomingSubscription.customerSubscriptionItemLeft.strength && <span className='my-recommendations__spec'>{upcomingSubscription.customerSubscriptionItemLeft.strength}</span>}
                        {upcomingSubscription.customerSubscriptionItemLeft.curve &&
                          <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.curve.short')}: {upcomingSubscription.customerSubscriptionItemLeft.curve}</span>}
                        {upcomingSubscription.customerSubscriptionItemLeft.diameter &&
                          <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.diameter.short')}: {upcomingSubscription.customerSubscriptionItemLeft.diameter}</span>}
                        {upcomingSubscription.customerSubscriptionItemLeft.cylinder &&
                          <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.cylinder.short')}: {upcomingSubscription.customerSubscriptionItemLeft.cylinder}</span>}
                        {upcomingSubscription.customerSubscriptionItemLeft.axis &&
                          <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.axis')}: {upcomingSubscription.customerSubscriptionItemLeft.axis}</span>}
                        {upcomingSubscription.customerSubscriptionItemLeft.add &&
                          <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.addfield')}: {upcomingSubscription.customerSubscriptionItemLeft.add}</span>}
                        {upcomingSubscription.customerSubscriptionItemLeft.color &&
                          <span className='my-recommendations__spec'>{' '}{translate('coptikk.product.color')}: {upcomingSubscription.customerSubscriptionItemLeft.color}</span>}
                      </div>
                    </div>
                    <div className='my-recommendations__eye-row'>
                      <div className='my-recommendations__eye'>
                        {translate('coptikk.subscription.edit.product')}:
                      </div>
                      <div className={'my-recommendations__spec-row'}>
                        <span className='my-recommendations__spec'>{upcomingSubscription.customerSubscriptionItemLeft.name}</span>
                      </div>
                    </div>
                  </div>}
                  {upcomingSubscription.clinicalPartActive && <div className='clinical-active'>{translate("coptikk.subscription.edit.clinicalpartincluded")}</div>}
                </div>
              }
            </div>
          </div>
        </> :
          <>
            <MyPageSubscriptionEdit customerId={customerSubscription.customerSystemId} refreshExistingSubscription={refreshExistingSubscription}
              subscriptionToEdit={customerSubscription} hideEdit={() => seteditClicked(false)}></MyPageSubscriptionEdit>
          </>}
      </> : <div className="mypage-subscription__nosubscription">{translate("coptikk.subscription.nosubscriptions")}</div>}
    </Fragment>
  );
}

export default MyPageSubscription;